import AccountService from '~/services/account'
import SET_IDENTITY from '~/common/mutations'

export default {
    state: {
        // 用户ID
        id: 0,
        // 用户名称
        name: "",
        // 用户邮箱
        email: "",
        // 用户手机号
        mobile: "",
        // 用户登录口令
        access_token: AccountService.getAccessTokenByCache(),
        // 用户允许访问路由
        allow_routes: [],
        // 用户角色
        role_id: '',
        // 用户缓存
        cache: [],
    },

    mutations: {
        setIdentity: (state, identity) => {
            state.id = identity.id;
            state.name = identity.name;
            state.email = identity.email;
            state.mobile = identity.mobile;
            state.access_token = identity.access_token;
            state.allow_routes = identity.allow_routes;
            state.role_id = identity.role_id;
            state.cache = identity.cache;
        },
        setId: (state, userId) => {
            state.id = userId;
        },
        setName: (state, name) => {
            state.name = name;
        },
        setEmail: (state, email) => {
            state.email = email;
        },
        setMobile: (state, mobile) => {
            state.mobile = mobile;
        },
        setAccessToken: (state, token) => {
            state.acccess_token = token;
        },
        setAllowRoutes: (state, allow_routes) => {
            state.allow_routes = allow_routes;
        },
        setRoleId: (state, role_id) => {
            state.role_id = role_id;
        },
        setCache: (state, cache) => {
            state.cache = cache;
        }
    },
    actions: {

        // 登录
        login({commit}, form) {
            return new Promise((resolve, reject) => {
                //每次发起登录首先清除本地缓存
                AccountService.clearCache();
                AccountService.login(form.username, form.password).then(res => {
                    if (res == true) {
                        commit('setIdentity', AccountService.getAccessTokenByCache());
                        resolve(res);
                    } else {
                        resolve(res);
                    }
                }).catch(error => {
                    reject(error);
                });
            });
        },

        // 退出登录
        logout({commit, state}) {
            return new Promise((resolve, reject) => {
                AccountService.logout().then(res => {
                    commit('setIdentity', {id: 0, name: '', email: '', mobile: '', access_token: '', allow_routes: [], role_id: ''})
                    resolve();
                }).catch(error => {
                    reject(error)
                })
            })
        },

        // 获取用户身份信息
        getUserIdentity({commit, state}) {
            return new Promise((resolve, reject) => {
                AccountService.getInfo().then(res => {
                    if (res && res.code == 0) {
                        commit('setIdentity', res.data);
                        resolve(res);
                    }
                    // else {
                    //   dispatch('logout').then(() => {
                    //     location.reload();
                    //   });
                    // }
                }).catch(error => {
                    reject(error);
                })
            })
        },

        // 清除前端缓存
        clearCache({commit}) {
            return new Promise((resolve, reject) => {
                AccountService.clearCache();
                commit('setIdentity', {id: 0, name: '', email: '', mobile: '', access_token: ''})
                resolve();
            });
        },

        refreshToken({commit}) {
            return new Promise((resolve, reject) => {
                AccountService.refreshAccessToken().then(res => {
                    if (res) {
                        commit('setIdentity', res);
                    }
                    resolve(res);
                });
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js